import { render, staticRenderFns } from "./ContactChannels.vue?vue&type=template&id=2f59e8cd"
import script from "./ContactChannels.vue?vue&type=script&lang=js"
export * from "./ContactChannels.vue?vue&type=script&lang=js"
import style0 from "./ContactChannels.vue?vue&type=style&index=0&id=2f59e8cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports